import {
    IFeatureToggleSetting,
} from '../types/feature-toggle-setting';

import {
    atom,
    useRecoilState,
} from 'recoil';

import {
    getFeatureToggleSettingFetch,
} from '../fetches/get-feature-toggle-setting.fetch';
import {
    IGetFeatureToggleSettingResponse,
} from '../responses/get-feature-toggle-setting.response';

const featureToggleSettingAtom = atom<IFeatureToggleSetting | null>({
    key: 'featureToggleSettingAtom',
    default: null,
});

export function useFeatureToggleSetting() {
    const [featureToggleSetting, setFeatureToggleSetting] = useRecoilState(featureToggleSettingAtom);

    const getFeatureToggleSetting = async (): Promise<IGetFeatureToggleSettingResponse> => {
        const res = await getFeatureToggleSettingFetch();

        if (!res.setting || res.error) {
            console.log(res.error);

            return res;
        }

        setFeatureToggleSetting(res.setting);

        return res;
    };

    return {
        featureToggleSetting,
        getFeatureToggleSetting,
    };
}
